<template>
  <b-modal
    :id="modalId"
    centered
    size="xl"
    hide-footer
    dialog-class="align-items-stretch px-md-3"
    @hidden="resetData"
    @shown="hideAllTooltips"
  >
    <template v-slot:modal-title>
      <small>
        <b class="text-secondary">ID:#{{ itemId }}</b>
      </small>
      <h5 class="font-weight-bold mb-0">{{ position }}</h5>
    </template>
    <template v-if="showArrows">
      <button
        class="modal-layer-navigation modal-layer-navigation--left h2 mb-0 border-0 bg-transparent d-none d-sm-block"
        @click.prevent="prevIterator"
      >
        <b-icon icon="arrow-left-circle" class="text-white" />
      </button>
      <button
        class="modal-layer-navigation modal-layer-navigation--right h2 mb-0 border-0 bg-transparent d-none d-sm-block"
        @click.prevent="nextIterator"
      >
        <b-icon icon="arrow-right-circle" class="text-white" />
      </button>
    </template>
    <b-overlay :show="loading" rounded="sm" class="h-100">
      <div class="bg-light h-100 d-flex flex-column">
        <div class="flex-grow-1">
          <slot />
        </div>
        <div v-if="showArrows" class="d-flex d-sm-none justify-content-end">
          <button class="h3 mb-0 bg-transparent border-0" @click.prevent="prevIterator">
            <b-icon icon="arrow-left" class="text-secondary" />
          </button>
          <button class="h3 mb-0 bg-transparent border-0" @click.prevent="nextIterator">
            <b-icon icon="arrow-right" class="text-secondary" />
          </button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ModalLayer extends Vue {
  @Prop({ type: String, default: '' }) modalId!: string;

  @Prop({ type: [String, Number], default: '' }) itemId!: string | number;

  @Prop({ type: String, default: '' }) position!: string;

  @Prop({ type: Boolean, default: false }) showArrows!: boolean;

  @Prop({ type: Boolean, default: true }) loading!: boolean;

  resetData() {
    this.$emit('reset-data');
  }

  nextIterator() {
    this.$emit('next');
  }

  prevIterator() {
    this.$emit('prev');
  }

  hideAllTooltips() {
    // fix for mobile devices
    this.$root.$emit('bv::hide::tooltip');
  }
}
</script>

<style lang="scss" scoped>
.modal-layer-navigation {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  &--left {
    left: -45px;
  }

  &--right {
    right: -45px;
  }
}
</style>
